import React from 'react';
import LegalPage from '../components/LegalPage';
import Seo from '../components/Seo';

export default function RefundPage() {
  return (
    <LegalPage title="Refund Policy">
      <Seo
        path="/refunds"
        title="Refund Policy — LottoPickle"
        description="LottoPickle's policy on subscription cancellations, refunds, and billing corrections."
      />
      <p><em>Last updated: April 9, 2026</em></p>

      <h2>1. Digital Subscription Policy</h2>
      <p>
        LottoPickle offers monthly and annual digital subscriptions to LottoPickle Premium.
        Because our service is delivered digitally and access is granted immediately upon payment,
        all subscription purchases are generally non-refundable.
      </p>

      <h2>2. Cancellation</h2>
      <p>
        You may cancel your subscription at any time from your{' '}
        <a href="/account">Account page</a>. Upon cancellation, you will retain full
        Premium access until the end of your current billing period. No further charges
        will be made after that date.
      </p>

      <h2>3. Exceptions</h2>
      <p>We will consider refund requests on a case-by-case basis in the following circumstances:</p>
      <ul>
        <li>A technical error on our part prevented you from accessing the service after payment</li>
        <li>You were charged for a renewal after completing a valid cancellation</li>
        <li>A duplicate charge occurred due to a billing error</li>
      </ul>
      <p>
        To request a refund under these circumstances, contact us at{' '}
        <a href="mailto:support@lottopickle.com">support@lottopickle.com</a> within
        14 days of the charge with your account email and a description of the issue.
      </p>

      <h2>4. Annual Subscriptions</h2>
      <p>
        Annual subscriptions may be eligible for a prorated refund within 7 days of the
        initial purchase if you have not made significant use of the Premium features.
        Contact us at <a href="mailto:support@lottopickle.com">support@lottopickle.com</a> to
        discuss your situation.
      </p>

      <h2>5. Processing</h2>
      <p>
        Approved refunds are returned to the original payment method within 5–10 business days,
        depending on your card issuer. Payments are processed by Stripe.
      </p>

      <h2>6. Contact</h2>
      <p>
        For refund requests or billing questions, contact us at{' '}
        <a href="mailto:support@lottopickle.com">support@lottopickle.com</a>.
      </p>
    </LegalPage>
  );
}
